module.exports = __webpack_public_path__ + "img/servicea.89602f66.png";